// Mock data for Barnston Court Nursing Home

export const careTypes = [
  {
    id: 1,
    title: "Nursing Care",
    description: "24/7 registered nursing support for complex health needs and medical conditions.",
    details: "Our qualified nursing team provides round-the-clock care for residents with complex medical needs, working closely with GPs and healthcare professionals.",
    suitable: "For individuals with chronic conditions, post-operative recovery, or complex medical needs",
    support: "Registered nurses on-site 24/7, medication administration, wound care, catheter care, and liaison with healthcare professionals",
    image: "https://images.pexels.com/photos/9893525/pexels-photo-9893525.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Dementia Care",
    description: "Specialist dementia support with trained staff and structured routines in a safe environment.",
    details: "Our dementia care team is specially trained to provide person-centred support, creating a calm, structured environment that helps residents feel secure and valued.",
    suitable: "For individuals living with Alzheimer's, dementia, or memory-related conditions",
    support: "Dementia-trained staff, memory activities, structured routines, safe secure environment, and family support",
    image: "https://images.pexels.com/photos/8940023/pexels-photo-8940023.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "End of Life Care",
    description: "Compassionate end of life support with dignity and comfort for residents and families.",
    details: "Our end of life care provides compassionate support during this important time, focusing on comfort, dignity, and quality of life. We work closely with palliative care teams and support families throughout.",
    suitable: "For individuals requiring palliative or end of life care support",
    support: "Pain management, comfort care, emotional support, family involvement, and bereavement support",
    image: "https://images.pexels.com/photos/7551677/pexels-photo-7551677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 4,
    title: "Bariatric Care",
    description: "Specialised care for individuals with higher weight needs, with appropriate equipment and trained staff.",
    details: "Our bariatric care service provides dignified, person-centred support for individuals with higher body weight. We have specialist equipment, wider doorways, and staff trained in safe moving and handling techniques.",
    suitable: "For individuals requiring specialist bariatric support and equipment",
    support: "Specialist bariatric equipment, trained staff, nutritional support, mobility assistance, and dignity-focused care",
    image: "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxudXJzZSUyMGNhcmluZyUyMGVsZGVybHklMjBwYXRpZW50JTIwZGlnbml0eSUyMGNvbWZvcnR8ZW58MHx8fHwxNzc2NjIyMzQ0fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const cqcRating = {
  overall: "Good",
  ratings: [
    { category: "Safe", rating: "Good" },
    { category: "Effective", rating: "Good" },
    { category: "Caring", rating: "Good" },
    { category: "Responsive", rating: "Good" },
    { category: "Well-Led", rating: "Good" }
  ],
  lastInspection: "2024",
  registrationNumber: "CQC-XXXXXX"
};

export const overallRating = {
  score: 9.4,
  maxScore: 10,
  totalReviews: 47,
  breakdown: [
    { category: "Care & Support", score: 9.6, reviews: 45 },
    { category: "Staff", score: 9.5, reviews: 47 },
    { category: "Management", score: 9.2, reviews: 42 },
    { category: "Cleanliness", score: 9.7, reviews: 46 },
    { category: "Food & Nutrition", score: 9.1, reviews: 44 },
    { category: "Activities", score: 8.9, reviews: 41 },
    { category: "Value for Money", score: 9.3, reviews: 38 }
  ],
  lastReviewDate: "December 2024"
};

export const reviews = [
  {
    id: 1,
    rating: 10,
    reviewer: "Sarah Thompson",
    relationship: "Daughter of resident",
    careType: "Dementia Care",
    stayDuration: "18 months",
    date: "December 2024",
    verified: true,
    title: "Exceptional care for my mother",
    review: "The team at Barnston Court have been absolutely wonderful. Mum settled in quickly and the dementia-trained staff know exactly how to support her. The activities coordinator is brilliant and keeps everyone engaged. We couldn't ask for better care."
  },
  {
    id: 2,
    rating: 9,
    reviewer: "James Mitchell",
    relationship: "Son of resident",
    careType: "Nursing Care",
    stayDuration: "2 years",
    date: "November 2024",
    verified: true,
    title: "Professional and compassionate",
    review: "Dad requires complex nursing care and the registered nurses here are exceptional. They work closely with his consultant and keep us informed every step of the way. The home is always spotless and the food has improved significantly since Cozee Care took over."
  },
  {
    id: 3,
    rating: 10,
    reviewer: "Linda Patterson",
    relationship: "Wife of resident",
    careType: "Residential Care",
    stayDuration: "9 months",
    date: "October 2024",
    verified: true,
    title: "It truly feels like home",
    review: "My husband loves it here. The staff treat him with such dignity and respect. I visit daily and always find him well cared for, clean, and happy. The garden is beautiful and he enjoys sitting out there. The transition to Cozee Care has been seamless."
  },
  {
    id: 4,
    rating: 9,
    reviewer: "Robert Hughes",
    relationship: "Son of resident",
    careType: "Dementia Care",
    stayDuration: "14 months",
    date: "September 2024",
    verified: true,
    title: "Dementia care excellence",
    review: "Mum has advanced dementia and the team handle everything with such patience and skill. They've created memory boxes and use techniques that really help her feel secure. Communication with family is excellent. Very impressed with the standard of care."
  },
  {
    id: 5,
    rating: 8,
    reviewer: "Margaret Davies",
    relationship: "Daughter of resident",
    careType: "Residential Care",
    stayDuration: "6 months",
    date: "August 2024",
    verified: true,
    title: "Good care, friendly staff",
    review: "Overall very pleased with the care Dad receives. Staff are friendly and responsive. The only reason for not giving 10/10 is that sometimes activities could be more varied, but this is a minor point. Would definitely recommend to others."
  },
  {
    id: 6,
    rating: 10,
    reviewer: "Elizabeth Turner",
    relationship: "Daughter of resident",
    careType: "Nursing Care",
    stayDuration: "3 years",
    date: "July 2024",
    verified: true,
    title: "Outstanding in every way",
    review: "Mum has been here for three years and the consistency of care is remarkable. Staff turnover is low which means continuity for residents. The manager is approachable and any concerns are dealt with immediately. Cannot fault Barnston Court."
  }
];

export const bedAvailability = {
  residential: { available: 2, total: 12 },
  nursing: { available: 0, total: 10 },
  dementia: { available: 1, total: 8 },
  lastUpdated: "Today"
};

export const keyFacts = [
  { label: "Total Beds", value: "30" },
  { label: "Garden Access", value: "Yes" },
  { label: "Lift Access", value: "Yes" },
  { label: "Parking", value: "Available" },
  { label: "Visiting Hours", value: "Flexible" },
  { label: "Funding Accepted", value: "All Types" },
  { label: "Dementia Specialist", value: "Yes" },
  { label: "End-of-Life Care", value: "Yes" },
  { label: "Learning Disability Support", value: "Yes" }
];

export const faqs = [
  {
    question: "What is the admission process?",
    answer: "Our admission process begins with an initial consultation where we assess care needs. This is followed by a pre-admission visit to the home, a comprehensive care assessment, and a trial period if desired. We work closely with families to ensure a smooth transition."
  },
  {
    question: "Can we visit anytime?",
    answer: "Yes, we operate flexible visiting hours and families are welcome to visit at any time. We encourage regular visits as they're beneficial for residents' wellbeing. We only ask that you inform us if visiting during mealtimes so we can accommodate you comfortably."
  },
  {
    question: "What does the weekly fee include?",
    answer: "Our weekly fee includes accommodation, all meals and snacks, 24-hour care and support, activities programme, laundry service, utilities, and personal care. Additional costs may include hairdressing, chiropody, and specific therapies if required."
  },
  {
    question: "Are pets allowed?",
    answer: "We understand how important pets are to people. While residents cannot bring their own pets to live permanently, we welcome visiting pets and have regular pet therapy visits. We assess each situation individually."
  },
  {
    question: "How are care plans created?",
    answer: "Care plans are developed in consultation with the resident, their family, and our care team. We conduct a comprehensive assessment covering physical, emotional, and social needs. Plans are reviewed regularly and updated as needs change."
  },
  {
    question: "What happens if care needs change?",
    answer: "We continuously monitor residents' needs and adapt care accordingly. If needs increase, we work with families and healthcare professionals to provide appropriate support. In most cases, we can accommodate changing needs within the home."
  },
  {
    question: "What meals are provided?",
    answer: "We provide three home-cooked meals daily, plus morning and afternoon refreshments and evening supper. Menus are varied and nutritious, with choices available. We cater for special dietary requirements, cultural preferences, and modified texture diets."
  },
  {
    question: "Do you accept NHS funding?",
    answer: "Yes, we accept NHS Continuing Healthcare funding, local authority funding, and self-funding residents. Our team can guide you through the funding application process and help determine eligibility."
  }
];

export const careers = {
  openRoles: [
    {
      title: "Care Assistant",
      type: "Full-time / Part-time",
      description: "Join our compassionate care team providing personal care and support to residents",
      requirements: ["NVQ Level 2/3 in Care (desirable)", "Compassionate nature", "Good communication skills"]
    },
    {
      title: "Registered Nurse (RGN)",
      type: "Full-time",
      description: "Lead nursing care for residents with complex health needs",
      requirements: ["Valid NMC registration", "Experience in elderly care", "Leadership skills"]
    },
    {
      title: "Senior Care Assistant",
      type: "Full-time",
      description: "Support the care team and take on supervisory responsibilities",
      requirements: ["NVQ Level 3 in Care", "2+ years care experience", "Leadership potential"]
    },
    {
      title: "Activities Coordinator",
      type: "Part-time",
      description: "Plan and deliver engaging activities for residents",
      requirements: ["Creative and enthusiastic", "Experience with elderly people", "Activity qualification desirable"]
    }
  ],
  benefits: [
    "Ongoing training and development",
    "Clear career progression pathways",
    "Competitive hourly rates",
    "Pension scheme",
    "Flexible shift patterns",
    "DBS check support",
    "Supportive team environment",
    "Employee wellbeing programme"
  ]
};

export const awards = [
  { title: "CQC Rated Good", year: "2024", icon: "award" },
  { title: "Food Hygiene Rating 5", year: "2024", icon: "utensils" },
  { title: "Cozee Care Quality Standard", year: "2024", icon: "star" },
  { title: "Dementia Care Excellence", year: "2023", icon: "brain" }
];

export const regulatoryHistory = [
  { year: "2025", event: "Ongoing quality improvements under Cozee Care" },
  { year: "2024", event: "Successful transition to Cozee Care ownership" },
  { year: "2023", event: "CQC inspection - Good rating maintained" },
  { year: "2022", event: "CQC inspection - Rated Good across all areas" }
];

export const fundingOptions = [
  {
    type: "Self-Funding",
    description: "Pay privately for care with flexible payment options available",
    suitability: "Those with savings, property, or income to fund care"
  },
  {
    type: "Local Authority Funding",
    description: "Council-funded care for those who meet eligibility criteria",
    suitability: "Those with capital below £23,250 (subject to assessment)"
  },
  {
    type: "NHS Continuing Healthcare",
    description: "Fully funded NHS care for those with significant health needs",
    suitability: "Those with complex or intense healthcare needs"
  },
  {
    type: "Top-Up Fees",
    description: "Family contributions to cover the difference between council funding and our fees",
    suitability: "When LA funding doesn't cover full costs"
  }
];

export const trustSignals = [
  { icon: "clock", text: "24/7 Nursing Support" },
  { icon: "brain", text: "Dementia Trained Staff" },
  { icon: "heart", text: "Person-Centred Care" },
  { icon: "users", text: "Family Involvement" },
  { icon: "shield", text: "Safeguarding Commitment" },
  { icon: "pill", text: "Medication Management" }
];

export const testimonials = [
  {
    id: 1,
    text: "The staff are incredibly kind and attentive. We always feel welcomed and reassured when we visit. Dad has settled in wonderfully.",
    author: "Family Member",
    role: "Daughter of Resident"
  },
  {
    id: 2,
    text: "Mum is treated with dignity and compassion every single day. The care team go above and beyond to make her feel at home.",
    author: "Relative",
    role: "Son of Resident"
  },
  {
    id: 3,
    text: "From the first visit, we knew this was the right place. The warmth and professionalism of the team is outstanding.",
    author: "Family Member",
    role: "Family Representative"
  }
];

export const facilities = [
  {
    title: "Comfortable Lounges",
    description: "Spacious, welcoming lounges with comfortable seating and natural light",
    image: "https://customer-assets.emergentagent.com/job_81c4535c-71eb-4a2b-bbef-6e28bbec7a64/artifacts/14afo2jv_bookArea.jpg"
  },
  {
    title: "Dining Areas",
    description: "Elegant dining spaces where residents enjoy freshly prepared meals together",
    image: "https://customer-assets.emergentagent.com/job_81c4535c-71eb-4a2b-bbef-6e28bbec7a64/artifacts/prx18cw4_IMG_1121.jpeg"
  },
  {
    title: "Beautiful Gardens",
    description: "Landscaped gardens for residents to enjoy fresh air and nature",
    image: "https://customer-assets.emergentagent.com/job_81c4535c-71eb-4a2b-bbef-6e28bbec7a64/artifacts/3pymvr10_backyard2.png"
  },
  {
    title: "Private Rooms",
    description: "Comfortable single bedrooms with personal touches",
    image: "https://customer-assets.emergentagent.com/job_81c4535c-71eb-4a2b-bbef-6e28bbec7a64/artifacts/4ld69ge8_DSC_0064-1024x683.jpg"
  }
];

export const amenities = [
  "Single bedrooms",
  "Comfortable lounges",
  "Elegant dining areas",
  "Beautiful conservatory",
  "Landscaped gardens",
  "Step-free access throughout",
  "Assisted bathing facilities",
  "Professional hairdressing services",
  "Home-cooked nutritious meals",
  "Flexible mealtimes",
  "Special dietary requirements catered for",
  "Daily activity programme",
  "Gentle exercise sessions",
  "Day trips and outings",
  "Religious and cultural support"
];

export const activities = [
  "Arts & crafts sessions",
  "Music and singing",
  "Themed celebration days",
  "Gentle exercise classes",
  "One-to-one engagement",
  "Community events",
  "Birthday celebrations",
  "Memory activities",
  "Garden activities"
];

export const contactFormSubmit = (formData) => {
  // Mock form submission
  console.log("Contact form submitted:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Thank you for your enquiry. We'll be in touch within 24 hours."
      });
    }, 1000);
  });
};

export const careerApplicationSubmit = (formData) => {
  // Mock career application submission
  console.log("Career application submitted:", formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: "Thank you for your application. Our HR team will review and contact you soon."
      });
    }, 1000);
  });
};
